import { Component, OnInit } from '@angular/core';
import {ProdottiStoreService} from "../../Progetti/_services/prodotti-store.service";
import {ApiRestService as ProgettiApiRestService} from "../../Progetti/_services/api-rest.service";
import {Location} from "@angular/common";
import {Prodotto} from "../../Progetti/Models/Prodotto";
import {TranslateObj} from "../../shared/models/translatedesc";
import {ActivatedRoute} from "@angular/router";
import {ClassicType} from "../../shared/models/ClassicType";
import {Categorie} from "../../Progetti/Models/Categorie";

@Component({
  selector: 'app-product-translations',
  templateUrl: './product-translations.component.html'
})
export class ProductTranslationsComponent implements OnInit {
  private id: number;
  Item: Prodotto = new Prodotto();
  private TipologieSelezionate: ClassicType[];
  CategorieObject: Categorie[] = [];
  immagineField: string = undefined;
  private immaginenome: string = undefined;
  schedaField: string = undefined;
  private schedanome: string = undefined;
  constructor(
    private progettiStore: ProdottiStoreService,
    private progettiApiRest: ProgettiApiRestService,
    private location: Location,
    private route: ActivatedRoute,
  ) {
    this.route.params.subscribe(data => {
      this.id = parseInt(data['id']);
      this.Refresh(this.id);
    })
  }

  ngOnInit(): void {
  }
  Refresh(id: number) {
    if(id) {
      this.progettiApiRest.getInfoProdotto({id: id}).subscribe(data => {
        this.Item = data;
        this.compilaForm(data);
      });
    }
  }
  private compilaForm(data: Prodotto) {
    this.TipologieSelezionate = data.tipoObject? [data.tipoObject]: [];
    this.CategorieObject = data.categorie ? data.categorie: [];
    this.Item.transaltedobjects = this.gettransaltedobjects(data);
    console.log(this.Item)
  }
  private getDaForm() {
    this.updateFields(this.Item?.transaltedobjects)
    var out: Prodotto = this.Item;
    out.categorie = this.getids(this.CategorieObject);
    out.tipo = this.getid(this.TipologieSelezionate);
    out.prodotto = this.Item?.transaltedobjects?.find(x => x.default)?.TranslateInputs?.find(x => x.id == "prodotto")?.value;
    out.descrizione = this.Item?.transaltedobjects?.find(x => x.default)?.TranslateInputs?.find(x => x.id == "descrizione")?.value;
    out.descrizioneBreve = this.Item?.transaltedobjects?.find(x => x.default)?.TranslateInputs?.find(x => x.id == "descrizioneBreve")?.value;
    if (this.immagineField && this.immagineField.length > 60){
      out.immagine = this.immagineField;
      out.file = this.immaginenome;
    }
    if (this.schedaField && this.schedaField.length > 60){
      out.scheda = this.schedaField;
      out.filescheda = this.schedanome;
    }
    return out;
  }
  getids(value: any[]): number[]{
    const Output: number[] = [];
    value?.forEach(item=> Output.push(item.id));
    return Output;
  }
  getid(value: any[]): any{
    return value?.length > 0 && value[0]? value[0].id : undefined;
  }
  saveClick() {
    if (this.Item.id)
      this.progettiApiRest.updateProdotti(this.getDaForm()).subscribe(() => this.location.back());
    else
      this.progettiStore.addNewItem(this.getDaForm()).subscribe(() => this.location.back());
  }

  cancel() {
    this.location.back();
  }
  gettransaltedobjects(prodotto: Prodotto): TranslateObj[]{
    return [
      {
        default: true,
        lang: "it",
        TranslateInputs: [
          {id: "prodotto", label:"Prodotto", value: prodotto.prodotto, type: "text"},
          {id: "descrizione", label:"Descrizione", value: prodotto.descrizione, type: "textarea" },
          {id: "descrizioneBreve", label:"Descrizione breve", value: prodotto.descrizioneBreve, type: "textarea" },
        ]
      }
    ].concat(prodotto.traduzioni);
  }
  updateFields(translateObjects: TranslateObj[]){
    this.Item.traduzioni = translateObjects.filter(x => !x.default)
  }
}
